import { decode } from "html-entities";
import { addDays } from "date-fns";
export function formatTag(str) {
  return str.replace(/_/g, " ");
}
export function sixDecimalPlaces(str) {
  return Number(str).toFixed(6);
}

export function capitalizeWords(str) {
  // guard empty string
  if (!str || str.length === 0) return;
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function orderDaysOfWeek(daysObject) {
  const daysOrder = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const orderedDays = Object.entries(daysObject)
    .sort((a, b) => daysOrder.indexOf(a[0]) - daysOrder.indexOf(b[0]))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return orderedDays;
}
export function formatHtmlText(str) {
  // remove new lines
  return str.replace(/\n/g, "");
}
export function getUrlSlug(title) {
  // decode html entities
  return (
    decode(title)
      .toLowerCase()
      // fix ampersand/and
      .replace(/&/g, " and ")
      // fix apostrophes
      .replace(/'/g, "")
      // fix of other characters and put dashes
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  );
}
export function groupByWithOrder(array, keyFn) {
  const groups = {};
  const keysInOrder = [];
  for (const item of array) {
    const key = keyFn(item);
    if (!groups.hasOwnProperty(key)) {
      groups[key] = [];
      keysInOrder.push(key);
    }
    groups[key].push(item);
  }
  let groupResults = [];
  for (const key of keysInOrder) {
    groupResults.push(groups[key]);
  }
  return groupResults;
}

export function getWeekendDays() {
  // sunday: 0,
  // monday: 1,
  // tuesday: 2,
  // wednesday: 3,
  // thursday: 4,
  // friday: 5,
  // saturday: 6,
  const today = new Date();
  const currentDay = today.getDay();
  const startDay = currentDay === 6 ? 6 : 5;
  const endDay = 0;
  // Days until next startWeekday (0 means today if matching)
  const daysToStart = (startDay - currentDay + 7) % 7;
  const nextStart = addDays(today, daysToStart);

  // Days from nextStart to nextEnd
  const startDayOfWeek = nextStart.getDay();
  const daysToEnd = (endDay - startDayOfWeek + 7) % 7;
  // Ensure at least 0 (same day), or strictly after (use || 7 as above)
  const nextEnd = addDays(nextStart, daysToEnd);

  return [nextStart, nextEnd];
}

export function scrollToFeed(isActive, isInstant) {
  if (isActive && typeof window !== "undefined") {
    const listingsHeader = document
      .querySelector("#fun-listings-header")
      ?.getBoundingClientRect();
    const navbar = document
      .querySelector("#fun-navbar")
      ?.getBoundingClientRect();
    const listingsBar = document
      .querySelector('[fun-id="fun-listings-bar"]')
      ?.getBoundingClientRect();
    // guard
    if (!navbar || !listingsBar) return;
    // instant scroll to position
    if (isInstant) {
      // +3 small adjustment
      window.scroll(
        0,
        navbar.height - listingsBar.height + listingsHeader.height + 3,
      );
      return;
    }
    // smooth scroll to position
    window.scrollTo({
      top: listingsBar.top + window.scrollY - navbar.height,
      left: 0,
      behavior: "smooth",
    });
  }
}
